// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__fIkGM","ul":"Navigation_ul__ohCWq","li":"Navigation_li__uzd2W"};